/**
 * 方德 IM（fd-im）客户端聊天接口
 * @see YApi project fd-im (1886)
 */
import request from '@/utils/request'
import {  getLinkUrl, fdImUrl } from './config'

type dataType = any

const FD_IM_BASE = fdImUrl
const FD_CUS_BASE = `${fdImUrl}/forthright-invest-cus`

function formBody(data: Record<string, any>) {
  const params = new URLSearchParams()
  Object.keys(data || {}).forEach((key) => {
    const v = data[key]
    if (v !== undefined && v !== null && v !== '') {
      params.append(key, String(v))
    }
  })
  return params
}

export default {
  /** 获取 IM 账户（环信账号 + 客服信息） GET /api/1/account/info */
  getImAccount(data: dataType): Promise<any> {
    return request({
      url: `${FD_IM_BASE}/api/1/account/info`,
      method: 'get',
      params: data?.data ?? data,
      headers: data?.headers,
      sign: true,
      newSign: true,
    })
  },

  /** 查询消息列表 POST /api/1/client/messages/list */
  getMessageList(data: dataType): Promise<any> {
    const payload = data?.data ?? data
    return request({
      url: `${FD_IM_BASE}/api/1/client/messages/list`,
      method: 'post',
      data: formBody(payload),
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        ...(data?.headers || {}),
      },
      sign: true,
    })
  },

  /** 发送消息 POST /api/1/client/messages/send */
  sendMessage(data: dataType): Promise<any> {
    const payload = data?.data ?? data
    return request({
      url: `${FD_IM_BASE}/api/1/client/messages/send`,
      method: 'post',
      data: formBody(payload),
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        ...(data?.headers || {}),
      },
      sign: true,
    })
  },

  /** 1v1 WhatsApp 链接 */
  getWaLink(data: dataType): Promise<any> {
    return request({
      url: `${FD_CUS_BASE}/api/1/cus/base/wechatLink/waLink`,
      method: 'get',
      params: data?.data ?? data,
      headers: data?.headers,
      sign: true,
      newSign: true,
    })
  },

  /** 图片上传（沿用原客服上传） */
  getUpload(data: dataType): Promise<any> {
    return request({
      url: getLinkUrl + '/kf/chat/upload',
      method: 'post',
      data,
    })
  },
}
